import AdvancedSearchTabular from './tabular';

import CoreAdvancedSearch, {
    AdvancedSearchClassList,
    AdvancedSearchElements,
    AdvancedSearchSelectors,
    AdvancedSearchTexts,
} from 'ui-core/widgets/advanced-search/js/advanced-search';

import { ComponentInjector, ComponentSelector } from '@atypon/ui-utils';

class Texts extends AdvancedSearchTexts { }

class ClassList extends AdvancedSearchClassList { }

class Selectors extends AdvancedSearchSelectors {}

class Elements extends AdvancedSearchElements {}

interface AdvancedSearch {
    get elements(): Elements;
    get texts(): Texts;
    get classList(): ClassList;
    get selectors(): Selectors;
}

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class AdvancedSearch extends CoreAdvancedSearch {

    addEventListeners(): void {
        super.addEventListeners();
    }

    initTabular() {
        // send the onSearchAreaChange method to AdvancedSearchTabular to add event listener on searchArea select of the cloned element (when clone method is called)
        this.tabularListener = new AdvancedSearchTabular(this.elements.searchInFields, this.setSubmitButtonState.bind(this));
        this.tabularListener.initialize();
    }
}

export default AdvancedSearch;

export {
    Selectors as AdvancedSearchSelectors,
    Elements as AdvancedSearchElements,
    ClassList as AdvancedSearchClassList,
    Texts as AdvancedSearchTexts,
};